import { AssistantResponseTokenV2 } from 'generated/graphql';

interface ConstructMarkdownFromAssistantResponseTokenProps {
  assistantResponseTokenV2List?: AssistantResponseTokenV2[];
  tokenToMarkdownConverter: (token: AssistantResponseTokenV2) => string;
}

export function constructMarkdownFromAssistantResponseToken({
  assistantResponseTokenV2List,
  tokenToMarkdownConverter,
}: ConstructMarkdownFromAssistantResponseTokenProps) {
  if (!assistantResponseTokenV2List) {
    return '';
  }

  const assistantResponseAnswerMarkdown = assistantResponseTokenV2List?.reduce(
    (markdownContent, tokenV2) => {
      return markdownContent + tokenToMarkdownConverter(tokenV2);
    },
    '',
  );

  return assistantResponseAnswerMarkdown ?? '';
}
